export enum SurveyType {
  CANDIDATE = "CANDIDATE",
}
